<template>
    <div class="page-title">
        <v-layout row wrap>
            <v-flex xs12 sm6>
               <h2 class="text-uppercase"> {{ title }} </h2>
               <h3> {{ subtitle }}</h3>
            </v-flex>
            <v-flex xs12 sm6>
                <p> {{ description }} </p>
            </v-flex>
        </v-layout>
        <hr>
    </div>
</template>

<script>
    export default {
        name: 'PageTitle',
        props: ['title', 'subtitle', 'description']
    }
</script>

<style>
    .page-title {
        font-family: 'Open Sans Condensed', sans-serif;
        margin-bottom: 15px;
    }
    .page-title h2 {
        color: #339900;
        font-size: 40px;
    }
    .page-title h3 {
        color: #354B4E;
        text-transform:uppercase;
    }
    .page-title p {
        font-size: 14px;
        font-style: italic;
    }
</style>

